import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useFacility } from "@/context/FacilityContext";
import { PageHeader } from "@/components/common/PageHeader";
import { ModuleManager } from "@/components/common/ModuleManager";

export default function EnabledModules() {
  const { auth } = useAuth();
  const { activeId, activeFacility, has } = useFacility();
  return (
    <div data-testid="enabled-modules-page">
      <PageHeader title="Enabled Modules" subtitle={activeFacility ? `Modules active at ${activeFacility.name}. Active modules appear in your navigation.` : "Select a facility."} />
      {activeId && <div className="bg-white/50 border border-slate-200 rounded-md p-5"><ModuleManager orgId={auth?.organisation?.id} facilityId={activeId} canEdit={has("module:edit")} /></div>}
    </div>
  );
}
